'use client';

import { useSimplifiedNavigation } from '../../hooks/useSimplifiedNavigation';

type NavigationSimplifierProps = {
  hideSignUpButton?: boolean;
};

// Renders nothing; mount inside a page/layout to request the simplified header while active.
export default function NavigationSimplifier({ hideSignUpButton = false }: NavigationSimplifierProps) {
  useSimplifiedNavigation(true, { hideSignUpButton });
  return null;
}
